/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import NotFound from 'bundles/phoenix/components/NotFound';

const styles = {
  gridContainer: css`
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;

    &::before,
    &::after {
      display: table;
      content: ' ';
    }

    &::after {
      clear: both;
    }

    @media (min-width: 768px) {
      width: 750px;
    }

    @media (min-width: 992px) {
      width: 970px;
    }

    @media (min-width: 1200px) {
      width: 1170px;
    }
  `,
};

const Promotions404 = () => (
  <div className="rc-PromotionsLandingPage">
    <div css={styles.gridContainer} className="p-t-3 p-b-3">
      <NotFound />
    </div>
  </div>
);

export default Promotions404;
